import PropTypes from "prop-types";

export default PropTypes.oneOf(["range", "value"]);
